module.exports = __webpack_public_path__ + "img/360.27ea069c.jpg";